import { enUS, zhCN, type Locale } from "date-fns/locale"

/** Tolgee locale → date-fns locale 映射 */
export const DATE_LOCALE_MAP: Record<string, Locale> = {
  be: enUS,
  cz: enUS,
  de: enUS,
  dk: enUS,
  en: enUS,
  es: enUS,
  fr: enUS,
  it: enUS,
  nl: enUS,
  pl: enUS,
  se: enUS,
  zh: zhCN,
}

/** 根据 locale 字符串获取 date-fns locale（服务端和客户端通用） */
export function getDateLocale(locale: string): Locale {
  return DATE_LOCALE_MAP[locale] || enUS
}
